import { render, staticRenderFns } from "./ExplosionComponent.vue?vue&type=template&id=1661c549&"
import script from "./ExplosionComponent.vue?vue&type=script&lang=js&"
export * from "./ExplosionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports